import { validateForm } from "../services/sendFormB2B";
import { $Q, $Qll } from "../utils/query-selector";
import { showRegisterForm } from "./registerCompany";

const validateCountry = (country) => {
  const countriesInput = $Q('[name="countries_ue"]');
  let data;

  if (countriesInput != null) {
    const countriesCode = countriesInput.value.split(";");

    // eslint-disable-next-line array-callback-return
    const result = countriesCode.filter((element) => {
      const elementCountry = element.split(":");

      if (elementCountry[0] === country) {
        return element;
      }
    });

    if (result.length > 0) {
      const code = result[0].split(":")[1];
      data = {
        isUE: true,
        coutryCode: code,
      }
    } else {
      data = {
        isUE: false,
      }
    }

    return data;
  }
}

const showError = (custom) => {

  const error = $Q(".error-section");
  error.classList.remove("hidden");
  if (custom === "euError") {
    const newMessage = $Q("#ue-error-message").value
    error.innerHTML = newMessage;
  } else if (custom === "duplicated") {
    const newMessage = $Q("#vat-taken-message").value
    error.innerHTML = newMessage;
  } else if (custom === "error") {
    const newMessage = $Q("#vat-error-message").value
    error.innerHTML = newMessage;
  }
}

const setSections = (sections, action) => {

  if (action === "hidden") {
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.add("hidden");
    }
  } else if (action === "show") {
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove("hidden");
    }
  }
}

// eslint-disable-next-line complexity
const submitForm = async (event, form) => {
  let formData;
  let companyVat;
  let country

  for (const input of event.target) {
    if (input.name === "vat_number_1") {
      companyVat = input.value
      formData = {
        "vat": companyVat,
      }
    }

    if (input.name === "country") {
      country = input.value
    }
  }
  const response = await validateForm("/v1/Vat", formData);
  const isEurope = validateCountry(country);

  if (response.isValid === true && isEurope.isUE === true) {
    const vatNumber = {
      "vatNumber": companyVat,
    }
    const ifCompanyExists = await validateForm("/v1/companyValidation", vatNumber);
    if (ifCompanyExists.response.exists) {
      showError("duplicated");
      return
    }
    form.classList.add("hidden");
    showRegisterForm(response.name, companyVat, isEurope.coutryCode);
    $Q(".error-section").classList.add("hidden");
  } else if (isEurope.isUE === false) {
    showError("euError");
  } else {
    showError("error");
  }
}

export const formVAT = () => {
  const form = $Q("#vat_validation");

  if (form != null) {

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      submitForm(e, form);
    })
  }
}

const changePrices = () => {

  let totalPrice = 0;

  if ($Q(".cartpage-footer__price")) {
    totalPrice = $Q(".cartpage-footer__price").getAttribute("data-price");
  }

  const cartVats = $Qll("#cart_estimate_vat");
  for (let i = 0; i < cartVats.length; i++) {
    cartVats[i].innerText = 0;
  }

  const totalPrices = $Qll("#btn_cart_total_price");
  for (let i = 0; i < totalPrices.length; i++) {
    totalPrices[i].innerText = totalPrice;
  }
}

const createDraftOrder = async (vatCode, country = "default") => {
  let taxable = true;
  const checkoutBtns = $Qll(".cartpage-footer__btn--btn");
  // eslint-disable-next-line prefer-template
  const url = window.Shopify.routes.root + 'cart.js';
  const cartContents = await fetch(url)
  .then((response) => response.json())
  .then((data) => data);

  if (country === "default") {
    changePrices();
    taxable = false;
  }

  const lineItems = cartContents.items;
  const items = [];

  for (let i = 0; i < lineItems.length; i++) {
    const item = {
      variant_id: lineItems[i].variant_id,
      quantity: lineItems[i].quantity,
      taxable: taxable,
    }
    items.push(item)
  }

  const draftOrderBody = {
    "draft_order": {
      // eslint-disable-next-line prefer-template
      "note": "VAT: " + vatCode,
      "tax_exempt": !taxable,
      "line_items": items,
    },
  }

  const res = await validateForm("/v1/createDraftOrder", draftOrderBody);

  for (let i = 0; i < checkoutBtns.length; i++) {
    checkoutBtns[i].setAttribute('href', res.response.invoice_url)
  }

}

// eslint-disable-next-line complexity
const submitVatForm = async (event) => {
  let formData;
  let companyVat;
  const errors = $Qll(".error-section");

  for (const input of event.target) {
    if (input.name === "sidecart_vat" || input.name === "cart_vat") {
      companyVat = input.value;
      formData = {
        "vat": companyVat,
      }
    }
  }

  const response = await validateForm("/v1/Vat", formData);

  if (response && response.isValid === true) {
    if (companyVat.trim().slice(0, 2).toUpperCase() === "FR") {
      const alerts = $Qll(".fr-alert-section");
      setSections(alerts, "show")
      createDraftOrder(companyVat, "FR");
    } else {
      createDraftOrder(companyVat);
    }
    setSections(errors, "hidden")
  } else {
    setSections(errors, "show")
  }
}

const toggleHideSections = (sections) => {
  for (let i = 0; i < sections.length; i++) {
    if (!sections[i].classList.contains('hidden')) {
      sections[i].classList.add("hidden");
    }
  }
}

const onChangeVatInput = () => {
  const errors = $Qll(".error-section");
  const alerts = $Qll(".fr-alert-section");
  toggleHideSections(errors);
  toggleHideSections(alerts);

  const checkoutBtns = $Qll(".cartpage-footer__btn--btn");
  for (let i = 0; i < checkoutBtns.length; i++) {
    checkoutBtns[i].setAttribute('href', "/checkout")
  }
}

export const cartVATValidation = () => {

  const form = $Q("#cart_vat_validation");
  const sideForm = $Q("#sidecart_vat_validation");

  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      submitVatForm(e)
    })
  }

  if (sideForm) {
    sideForm.addEventListener("submit", (e) => {
      e.preventDefault();
      submitVatForm(e)
    })
  }
}

export const vatInputValidation = () => {

  const buton = $Q("#cart_vat");
  const sideButon = $Q("#sidecart_vat");

  if (buton) {
    buton.addEventListener("input", (e) => {
      e.preventDefault();
      onChangeVatInput()
    })
  }

  if (sideButon) {
    sideButon.addEventListener("input", (e) => {
      e.preventDefault();
      onChangeVatInput()
    })
  }
}
